<div id="default-print" *ngIf="property && entityData && (template === 'template1' || template === 'template4')">
  <div class="align-items-center d-flex header ms-2 my-4">
    <div class="entity-logo p-3">
      <img class="float-end me-3"
        [src]="entityData?.transparentPagesLogo ? entityData?.transparentPagesLogo : entityData.cookiesLogo ? entityData.cookiesLogo : entityData.logo"
        width="120" />
      <!-- <img class="float-end me-3" src="https://admin-api.imodigi.com/entities/files/26-27-1716540321278-9fca615b-9349-4e5d-b710-9ae9c61c3186.png" width="120" /> -->
    </div>
    <div class="basic-info ms-3">
      <h3 *ngIf="entityData.name" class="fs-2 fw-bold">
        {{entityData.name}}
      </h3>
      <div class="align-items-center d-flex justify-content-between w-100">
        <div>
          <div *ngIf="entityAddress" class="fs-5 fw-normal"><span [innerHTML]="entityAddress"></span></div>
          <div *ngIf="entityData.phone" class="fs-5 fw-bold">{{entityData.phone}}</div>
          <div *ngIf="entityData.email" class="fs-5 fw-bold">{{entityData.email}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4 mx-4">
    <div *ngIf="property?.media && property?.media?.length > 0" class="gallery mb-4">
      <div class="row">
        <div class="position-relative"
          [ngClass]="{'col-12': property.media.length === 1, 'col-7': property.media.length > 1}">
          <img [src]="property.media[0].file" [alt]="property.media[0]?.description"
            class="property-image first-image fit-cover rounded-2 w-100 d-block">
          <div *ngIf="energyFile" [ngClass]="energyFile == 'A+' ? 'APlus' : energyFile" class="energy-area">
            <div *ngIf="energyFile != 'exempted'" class="energy">{{energyFile}}</div>
            <div *ngIf="energyFile == 'exempted'" class="energy"></div>
            <div class="base"></div>
          </div>
        </div>
        <div *ngIf="property.media.length > 1 " [ngClass]="{'grid-col-1': property.media.length === 2}"
          class="min-images col-5">
          <ng-container *ngFor="let img of property.media.slice(1, 3); let i = index">
            <div class="position-relative small-img d-flex align-items-center justify-content-center">
              <img [src]="img.file" [alt]="img?.description"
                class="property-image fit-cover h-100 w-100 rounded-2 d-block">
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="d-flex align-items-center mb-3 justify-content-between">
        <div>
          <h3 *ngIf="property?.title" class="fs-2 fw-bold property-title main-color">
            {{property.title}}
          </h3>
          <div *ngIf="property?.district">
            <span class="fs-5"><span *ngIf="property?.county">{{property.county}}, </span>{{property.district}}</span>
          </div>
        </div>
        <div>
          <h3 *ngIf="property?.price" class="fs-2 fw-bold">
            {{property.price && property.price != 0 && property.price != null ?
            priceFormat(property.price, property.currency) :
            't-on-request' | translate}}
          </h3>
        </div>
      </div>
      <h4 class="fw-bold">{{'t-details' | translate}}</h4>
      <div class="row mb-4">
        <div *ngIf="property.propertyType" class="col-4">
          <span class="fw-bold me-1">{{ "t-propertyType" | translate
            }}:</span>
          <span class="det">{{ property.propertyType }}</span>
        </div>
        <div *ngIf="property.businessType" class="col-4">
          <span class="fw-bold me-1">{{ "t-businessType" | translate
            }}:</span>
          <span class="det">{{ property.businessType }}</span>
        </div>
        <div *ngIf="property.propertyCondition" class="col-4">
          <span class="fw-bold me-1">{{ "FILTERS.PROPERTY-STATE.TEXT" | translate
            }}:</span>
          <span class="det">{{ property.propertyCondition }}</span>
        </div>
      </div>
      <h4 *ngIf="property.description" class="fw-bold">{{'t-description' | translate}}</h4>
      <p *ngIf="property.description" class="description" [innerHTML]="property.description"></p>
    </div>
    <div class="contacts mt-3">
      <div class="d-flex align-items-center justify-content-between">
        <div *ngIf="property?.agents?.length > 0" class="d-flex align-items-center">
          <img class="me-3" *ngIf="property?.agents?.length > 0" src="{{property.agents[0]?.profileImg}}" width="80">
          <div class="agent-info">
            <h4>{{property.agents[0]?.name}}</h4>
            <h4>{{property.agents[0]?.phone}}</h4>
            <h4>Ref: {{property.reference}}</h4>
          </div>
        </div>
        <div *ngIf="!property?.agents || property?.agents?.length == 0" class="d-flex align-items-center">
          <img class="me-3"
            src="{{entityData?.transparentPagesLogo ? entityData?.transparentPagesLogo : entityData.cookiesLogo ? entityData.cookiesLogo : entityData.logo}}"
            width="80">
          <div class="agent-info">
            <h4>{{entityData.name}}</h4>
            <h4>{{entityData.phone}}</h4>
            <h4>Ref: {{property.reference}}</h4>
          </div>
        </div>
        <div class="qr">
          <qrcode class="qr-code-image" [width]="120" [margin]="2" [qrdata]="qrCodeLink">
          </qrcode>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="property && entityData && template === 'template2'" id="template2" class="print-property mt-3">
  <div class="align-items-center d-flex header">
    <div class="entity-logo p-3">
      <img class="float-end me-3"
        [src]="entityData?.transparentPagesLogo ? entityData?.transparentPagesLogo : entityData.logo" width="120" />
      <!-- <img class="float-end me-3" src="https://admin-api.imodigi.com/entities/files/26-27-1716540321278-9fca615b-9349-4e5d-b710-9ae9c61c3186.png" width="120" /> -->
    </div>
    <div class="basic-info ms-3 mt-2">
      <h3 *ngIf="property?.title" class="fs-2 mb-0 fw-bold main-color">
        {{property.title}}
      </h3>
      <div class="align-items-center d-flex justify-content-between w-100">
        <div>
          <div *ngIf="property?.district" class="fs-5 fw-normal main-color">{{property.district}}</div>
          <div *ngIf="property?.reference" class="fs-5 fw-bold main-color">Ref: {{property.reference}}</div>
        </div>
        <h3 class="fs-2 fw-bold main-color">
          {{property.price && property.price != 0 && property.price != null ?
          priceFormat(property.price, property.currency) :
          't-on-request' | translate}}
        </h3>
      </div>
    </div>
  </div>
  <div class="mt-4 mx-4">
    <div *ngIf="property?.media && property?.media?.length > 0" class="gallery mb-4">
      <div class="row">
        <div class="position-relative"
          [ngClass]="{'col-12': property.media.length === 1, 'col-7': property.media.length > 1}">
          <img [src]="property.media[0].file" [alt]="property.media[0]?.description"
            class="property-image first-image rounded-5 w-100 d-block">
          <div *ngIf="energyFile" class="absolute-energy">
            <div [ngClass]="energyFile == 'A+' ? 'APlus' : energyFile" class="energy-area">
              <div *ngIf="energyFile != 'exempted'" class="energy">{{energyFile}}</div>
              <div *ngIf="energyFile == 'exempted'" class="energy"></div>
              <div class="base"></div>
            </div>
          </div>
        </div>
        <div *ngIf="property.media.length > 1 " [ngClass]="{'grid-col-1': property.media.length === 2}"
          class="min-images col-5">
          <ng-container *ngFor="let img of property.media.slice(1, 3); let i = index">
            <div
              [ngClass]="{'position-relative d-flex align-items-center justify-content-center': property.media.length == 2, 'small-img': property.media.length > 2}"
              *ngIf="i != 3">
              <img [src]="img.file" [alt]="img?.description" [ngClass]="{'h-min-img': property.media.length !== 2}"
                class="property-image h-100 rounded-5 d-block">
              <qrcode *ngIf="property.media.length == 2" class="qr-code-image position-absolute" [width]="120"
                [margin]="2" [qrdata]="qrCodeLink">
              </qrcode>
            </div>
            <div class="position-relative d-flex align-items-center justify-content-center small-img" *ngIf="i == 3">
              <img [src]="img.file" [alt]="img?.description"
                class="property-image img-with-qr h-100 h-min-img rounded-5 d-block">
              <qrcode class="qr-code-image position-absolute" [width]="120" [margin]="2" [qrdata]="qrCodeLink">
              </qrcode>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="content">
      <div *ngIf="hasDivisions" class="mb-4 row">
        <div *ngIf="hasDiv(property.divisions, 'Bedrooms', 'division')" class="align-items-center col-2 d-flex">
          <i class="fs-3 fw-bold main-color mdi mdi-bed me-1"></i>
          <span class="det">{{hasDiv(property.divisions, 'Bedrooms', 'division')?.value}}</span>
        </div>
        <div *ngIf="hasDiv(property.divisions, 'Bathrooms', 'division')" class="align-items-center col-2 d-flex"><i
            class="fs-3 fw-bold main-color mdi mdi-bathtub-outline me-1"></i><span class="det">{{hasDiv(property.divisions, 'Bathrooms', 'division')?.value}}</span></div>
        <div *ngIf="hasDiv(property.areas, 'grossArea', 'area')" class="align-items-center col-2 d-flex"><i class="fs-3 fw-bold main-color mdi mdi-crop me-1"></i><span
            class="det">{{hasDiv(property.areas, 'grossArea', 'area').value}} m²</span>
        </div>
      </div>
      <h4 class="main-color fw-bold">{{'t-details' | translate}}</h4>
      <div class="row mb-4">
        <div *ngIf="property.propertyType" class="col-4">
          <span class="fw-bold me-1">{{ "t-propertyType" | translate
            }}:</span>
          <span class="det">{{ property.propertyType }}</span>
        </div>
        <div *ngIf="property.businessType" class="col-4">
          <span class="fw-bold me-1">{{ "t-businessType" | translate
            }}:</span>
          <span class="det">{{ property.businessType }}</span>
        </div>
        <div *ngIf="property.propertyCondition" class="col-4">
          <span class="fw-bold me-1">{{ "FILTERS.PROPERTY-STATE.TEXT" | translate
            }}:</span>
          <span class="det">{{ property.propertyCondition }}</span>
        </div>
      </div>
      <h4 *ngIf="property.description" class="main-color fw-bold">{{'t-description' | translate}}</h4>
      <p *ngIf="property.description" class="description" [innerHTML]="property.description"></p>
    </div>
    <div class="contacts mt-3">
      <!-- <h4 class="main-color fw-bold">{{'t-contact-us' | translate}}</h4> -->
      <div class="d-flex align-items-center justify-content-between">
        <div *ngIf="property?.agents?.length > 0" class="d-flex align-items-center">
          <img class="me-3 rounded-circle" *ngIf="property?.agents?.length > 0" src="{{property?.agents[0]?.profileImg}}" width="150">
          <div class="agent-info">
            <h4 class="main-color">{{property?.agents[0]?.name}}</h4>
            <h4 class="main-color">{{property?.agents[0]?.phone}}</h4>
          </div>
        </div>
        <div *ngIf="!property?.agents || property?.agents?.length == 0" class="d-flex align-items-center">
          <img class="me-3"
            src="{{entityData?.transparentPagesLogo ? entityData?.transparentPagesLogo : entityData.logo}}" width="80">
          <div class="agent-info">
            <h4 class="main-color">{{entityData.name}}</h4>
            <h4 class="main-color">{{entityData.phone}}</h4>
          </div>
        </div>
        <div class="address">
          <p class="main-color text-end">AGII Center<br>Rua Cónego Luciano Afonso dos Santos, 37-B<br>4700-048
            Braga<br>{{'t-real-estate-license' | translate}}:
            24377</p>
        </div>
      </div>
      <small class="main-color">{{'t-agii-brochure' | translate}}</small>
    </div>
  </div>
</div>
